import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import { usePageMeta } from '@/hooks/usePageMeta'
import { trackEvent } from '@/lib/analytics'

const posts = [
  {
    id: 'where-were-you-september-11',
    title: 'Where Were You on September 11th?',
    subtitle: 'I know where I was.',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-september-11-newsletter.jpg',
    excerpt: `My mom called me that morning. She was frantic. "Have you seen the news?" I hadn't. I was just out of college, living in an apartment in the Pacific Northwest. I watched with my coworkers as the towers came down — knowing firefighters were still inside.`,
    url: 'https://ckarchive.com/b/8kuqhoh2776erf3n66mnqfkzql5gdc3h80n0p',
    platform: 'Newsletter',
    cta: 'Read Newsletter',
  },
  {
    id: 'not-invincible',
    title: "We're Not Invincible",
    subtitle: `This black belt martial artist could've been a firefighter.`,
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-not-invincible.webp',
    excerpt: `Imagine walking into a dojo or a firehouse, telling your Alpha mates you're in therapy.`,
    url: 'https://filmabeestudios.substack.com/p/were-not-invincible',
    platform: 'Substack',
    cta: 'Read on Substack',
  },
  {
    id: 'farmers-vs-fires',
    title: 'Farmers vs Fires',
    subtitle: 'The people who feed us are the same ones who fight the fire.',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-farmers-vs-fires.webp',
    excerpt: `They grow the food. They volunteer on the fireground. And when disaster strikes, they're the first ones there — before the trucks. This story is about the people no one thinks about until everything is burning.`,
    url: 'https://filmabeestudios.substack.com/p/farmers-vs-fires',
    platform: 'Substack',
    cta: 'Read on Substack',
  },
  {
    id: 'captain-minneman',
    title: 'Captain Brandon Minneman',
    subtitle: 'The man behind the mission — and why his story had to be told.',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-brandon-minneman.jpg',
    excerpt: `Some people carry a story so quietly you almost miss it. Captain Brandon Minneman is one of them. This issue goes inside what shaped him — and why the fire service needs more people willing to talk about it the way he does.`,
    url: 'https://ckarchive.com/b/68ueh8h5mgx9pskq88gqmtpzkeddma9h53o36',
    platform: 'Newsletter',
    cta: 'Read Newsletter',
  },
  {
    id: 'rooting-for',
    title: "Who're You Rooting For?",
    subtitle: 'Meet Lance Lawson — and ask yourself a harder question.',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-lance-lawson.jpg',
    excerpt: `Every great story needs someone to root for. In SPOKE, that person is Lance Lawson — a young firefighter walking into a culture that doesn't always talk about what it costs. This post is about why we follow people like Lance, and what it means to actually be in their corner.`,
    url: 'https://filmabeestudios.substack.com/p/whore-you-rooting-for',
    platform: 'Substack',
    cta: 'Read on Substack',
  },
  {
    id: 'mental-wellness',
    title: 'Mental Wellness on the Fireground',
    subtitle: 'The conversation firefighters are finally having — and what it costs when they don\'t.',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-mental-wellness.jpg',
    excerpt: `There are stadiums full of people who cheer for athletes who struggle publicly. But first responders carry their weight in silence, behind closed bay doors, far from the crowd. SPOKE is about opening those doors — and this issue is about why mental wellness in the fire service can't wait any longer.`,
    url: 'https://ckarchive.com/b/o8ukhqh6240x8hp2ww025aqen5n93uohmplp7',
    platform: 'Newsletter',
    cta: 'Read Newsletter',
  },
  {
    id: 'newsletter-01',
    title: 'Welcome to the Inside',
    subtitle: 'SPOKE Is Done. Now We Need You.',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/SPOKE_film_firehouse13_firefighter.jpg',
    excerpt: `You signed up because something about this story hit you. We are not going to waste that. With every issue we invite you deeper inside the film, the mission, and the conversation that needs to get louder. No fluff. Just the story and what you can do to help tell it. Welcome to the inside.`,
    url: 'https://ckarchive.com/b/0vuwh9h9638mdi7mggrmzhv7x5om2unh03l3p',
    platform: 'Newsletter',
    cta: 'Read Newsletter',
  },
  {
    id: 'the-dream',
    title: 'The Dream',
    subtitle: 'How to make a documentary with your subconscious',
    author: 'Filmabee Studios',
    image: '/spoke-static/images/spoke-firehouse13.jpg',
    excerpt: `I sprinted after two firefighters at the scene. A store owner was in trouble. He had stepped out into the street and slipped into quicksand. The firefighters hauled the poor man up before he completely disappeared. By the time I reached them, movie camera in hand, I took the lens cap off and hit record. I witnessed myself flying to the ground in slow motion, landing on my side, in disbelief at the rescue unfolding in front of me. One of the firefighters started CPR, and I knew the man would make it.`,
    url: 'https://filmabeestudios.substack.com/p/the-dream',
    platform: 'Substack',
    cta: 'Read on Substack',
  },
]

const BlogPage = () => {
  usePageMeta({
    title: 'Blog | SPOKE Film',
    description: 'Stories from behind the camera. Updates and insights from the SPOKE film team.',
  })
  return (
    <>
      <Navigation />

      {/* Hero */}
      <section className="relative min-h-[38vh] bg-[#0a0f1a] flex items-end pt-24 pb-16 px-6">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-[#0a0f1a]"></div>
        <div className="relative z-10 max-w-5xl mx-auto w-full text-center">
          <div className="w-12 h-1 bg-red-600 mb-6 mx-auto"></div>
          <h1 className="text-5xl md:text-7xl font-montserrat font-black uppercase tracking-wide text-white leading-none">
            Blog
          </h1>
          <p className="mt-4 text-yellow-400 font-poppins font-light text-lg">
            Never miss a shift. Follow our journey to the big screen.
          </p>
        </div>
      </section>

      {/* Blog grid */}
      <section className="bg-[#0a0f1a] py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post) => (
              <a
                key={post.id}
                href={post.url}
                onClick={() => {
                  if (post.platform === 'Substack') {
                    trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: 'substack', placement: 'blog_card' })
                  } else {
                    trackEvent('newsletter_click', {
                      site: 'spoke',
                      film: 'spoke',
                      placement: 'blog_card',
                      provider: post.url.includes('ckarchive.com') ? 'ckarchive' : 'kit',
                    })
                  }
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="group block bg-black border border-white/10 hover:border-yellow-400/40 transition-all duration-300 overflow-hidden"
              >
                {/* Image */}
                <div className="relative overflow-hidden aspect-[4/5]">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                  {/* Platform badge */}
                  <div className="absolute top-4 right-4 bg-black/60 backdrop-blur-sm border border-white/20 px-3 py-1">
                    <span className="font-montserrat font-black uppercase tracking-widest text-white text-xs">
                      {post.platform}
                    </span>
                  </div>
                </div>

                {/* Text */}
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-6 h-[2px] bg-red-600"></div>
                    <span className="font-montserrat font-black uppercase tracking-widest text-gray-400 text-xs">
                      {post.author}
                    </span>
                  </div>

                  <h2 className="font-montserrat font-black uppercase tracking-wide text-white text-2xl mb-1 group-hover:text-yellow-400 transition-colors duration-300">
                    {post.title}
                  </h2>
                  <p className="font-poppins font-light text-gray-400 text-sm mb-4 leading-relaxed">
                    {post.subtitle}
                  </p>

                  <p className="font-poppins font-light text-gray-300 text-sm leading-relaxed line-clamp-4">
                    {post.excerpt}
                  </p>

                  <div className="mt-6 flex items-center gap-2 text-yellow-400 group-hover:text-yellow-300 transition-colors duration-200">
                    <span className="font-montserrat font-black uppercase tracking-widest text-xs">{post.cta}</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </a>
            ))}

            {/* Placeholder cards for future posts */}
            <div className="hidden md:flex flex-col items-center justify-center border border-dashed border-white/10 min-h-[400px] p-8 text-center">
              <div className="w-8 h-[2px] bg-red-600 mb-6 mx-auto"></div>
              <p className="font-montserrat font-black uppercase tracking-widest text-gray-600 text-xs">
                More stories coming
              </p>
            </div>
          </div>

          {/* Substack CTA */}
          <div className="mt-20 text-center border-t border-white/10 pt-16">
            <div className="w-12 h-1 bg-yellow-400 mx-auto mb-8"></div>
            <h2 className="font-montserrat font-black uppercase tracking-wide text-white text-3xl md:text-4xl mb-4">
              Never Miss a Story
            </h2>
            <p className="font-poppins font-light text-gray-400 text-lg mb-8 max-w-xl mx-auto">
              Subscribe on Substack to get every new post directly in your inbox.
            </p>
            <a
              href="https://filmabeestudios.substack.com/"
              onClick={() => trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: 'substack', placement: 'blog_cta' })}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 font-montserrat font-black uppercase tracking-widest text-sm px-10 py-4 bg-yellow-400 text-black hover:bg-yellow-300 transition-colors duration-300"
            >
              Follow on Substack
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/>
              </svg>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default BlogPage
